// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_automation_history_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionKind } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { DemandAutoConfirmMethod, PlanCreationTime } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_automation_history_model.proto.
 */
export const file_bffuser_v1_workflow_automation_history_model: GenFile = /*@__PURE__*/
  fileDesc("CjJiZmZ1c2VyL3YxL3dvcmtmbG93X2F1dG9tYXRpb25faGlzdG9yeV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSKiAwoZQXV0b0V4ZWN1dGlvbkhpc3RvcnlFbnRyeRIOCgZsb2dfaWQYASABKAkSLwoLZXhlY3V0ZWRfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEkEKCHN1Yl9zdGVwGAMgASgLMi0uYmZmdXNlci52MS5BdXRvRXhlY3V0aW9uSGlzdG9yeVN1YlN0ZXBUYXJnZXRIABIsChF0YXJnZXRfZmlyc3RfZGF0ZRgFIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSKwoQdGFyZ2V0X2xhc3RfZGF0ZRgGIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSNgoGbWV0aG9kGAcgASgLMiYuYmZmdXNlci52MS5BdXRvRXhlY3V0aW9uSGlzdG9yeU1ldGhvZBIvCgZyZXN1bHQYCCABKA4yHy5iZmZ1c2VyLnYxLkF1dG9FeGVjdXRpb25SZXN1bHQSMwoFbm90ZXMYCSADKAsyJC5iZmZ1c2VyLnYxLkF1dG9FeGVjdXRpb25IaXN0b3J5Tm90ZUIICgZ0YXJnZXQiqgEKIUF1dG9FeGVjdXRpb25IaXN0b3J5U3ViU3RlcFRhcmdldBIYChB3b3JrZmxvd19jYXNlX2lkGAEgASgJEhMKC3dvcmtmbG93X2lkGAIgASgJEigKCWFyZWFfY29kZRgDIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlEhoKDXN1Yl9zdGVwX25hbWUYBCABKAlIAIgBAUIQCg5fc3ViX3N0ZXBfbmFtZSKiAQoaQXV0b0V4ZWN1dGlvbkhpc3RvcnlNZXRob2QSPgoPZGVtYW5kX2ZvcmVjYXN0GAEgASgOMiMuYmZmdXNlci52MS5EZW1hbmRBdXRvQ29uZmlybU1ldGhvZEgAEjoKC3BsYW5fY3JlYXRlGAIgASgLMiMuYmZmdXNlci52MS5QbGFuQ3JlYXRlSGlzdG9yeU1ldGhvZEgAQggKBm1ldGhvZCKCAQoXUGxhbkNyZWF0ZUhpc3RvcnlNZXRob2QSMgoJcGxhbl9raW5kGAEgASgOMh8uYmZmdHlwZXMudjEuUGxhblN1Ym1pc3Npb25LaW5kEjMKDWNyZWF0aW9uX3RpbWUYAiABKAsyHC5iZmZ1c2VyLnYxLlBsYW5DcmVhdGlvblRpbWUicQoYQXV0b0V4ZWN1dGlvbkhpc3RvcnlOb3RlEjMKBnJlYXNvbhgBIAEoDjIjLmJmZnVzZXIudjEuQXV0b0V4ZWN1dGlvbk5vdGVSZWFzb24SIAoFZGF0ZXMYAiADKAsyES5nb29nbGUudHlwZS5EYXRlKvsBChNBdXRvRXhlY3V0aW9uUmVzdWx0EiUKIUFVVE9fRVhFQ1VUSU9OX1JFU1VMVF9VTlNQRUNJRklFRBAAEiIKHkFVVE9fRVhFQ1VUSU9OX1JFU1VMVF9FWEVDVVRFRBABEisKJ0FVVE9fRVhFQ1VUSU9OX1JFU1VMVF9BV0FJVElOR19BUFBST1ZBTBACEicKI0FVVE9fRVhFQ1VUSU9OX1JFU1VMVF9BUFBST1ZBTF9IRUxEEAMSIQodQVVUT19FWEVDVVRJT05fUkVTVUxUX1NLSVBQRUQQBBIgChxBVVRPX0VYRUNVVElPTl9SRVNVTFRfRkFJTEVEEAUqwQIKF0F1dG9FeGVjdXRpb25Ob3RlUmVhc29uEioKJkFVVE9fRVhFQ1VUSU9OX05PVEVfUkVBU09OX1VOU1BFQ0lGSUVEEAASMgouQVVUT19FWEVDVVRJT05fTk9URV9SRUFTT05fREVNQU5EX0JHX05PVF9GT1VORBABEjEKLUFVVE9fRVhFQ1VUSU9OX05PVEVfUkVBU09OX01FVEhPRF9VTkRFQ0lEQUJMRRACEjIKLkFVVE9fRVhFQ1VUSU9OX05PVEVfUkVBU09OX05PX0FDVFVBTFNfQUxMX1pFUk8QAxIsCihBVVRPX0VYRUNVVElPTl9OT1RFX1JFQVNPTl9OT1RfQ09NUExFVEVEEAQSMQotQVVUT19FWEVDVVRJT05fTk9URV9SRUFTT05fUEFTVF9ERUxJVkVSWV9EQVRFEAVCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bffuser_v1_workflow_template_model, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * AutoExecutionHistoryEntry is one row of the 自動実行履歴
 * (auto-execution-history.md AC-AEH-006). For repeated skipped / failed /
 * held attempts merged into one row, every field is the last attempt's.
 *
 * @generated from message bffuser.v1.AutoExecutionHistoryEntry
 */
export type AutoExecutionHistoryEntry = Message<"bffuser.v1.AutoExecutionHistoryEntry"> & {
  /**
   * @generated from field: string log_id = 1;
   */
  logId: string;

  /**
   * @generated from field: google.protobuf.Timestamp executed_at = 2;
   */
  executedAt?: Timestamp;

  /**
   * @generated from oneof bffuser.v1.AutoExecutionHistoryEntry.target
   */
  target: {
    /**
     * 4 is left for the plan target of 計画の自動再提出 (AC-AEH-002), which has
     * no workflow or sub-step.
     *
     * @generated from field: bffuser.v1.AutoExecutionHistorySubStepTarget sub_step = 3;
     */
    value: AutoExecutionHistorySubStepTarget;
    case: "subStep";
  } | { case: undefined; value?: undefined };

  /**
   * target_first_date / target_last_date are the 対象受渡日; equal for a
   * single-day attempt.
   *
   * @generated from field: google.type.Date target_first_date = 5;
   */
  targetFirstDate?: Date;

  /**
   * @generated from field: google.type.Date target_last_date = 6;
   */
  targetLastDate?: Date;

  /**
   * @generated from field: bffuser.v1.AutoExecutionHistoryMethod method = 7;
   */
  method?: AutoExecutionHistoryMethod;

  /**
   * @generated from field: bffuser.v1.AutoExecutionResult result = 8;
   */
  result: AutoExecutionResult;

  /**
   * notes are the 備考 in the spec's order without duplicates (AC-AEH-004).
   *
   * @generated from field: repeated bffuser.v1.AutoExecutionHistoryNote notes = 9;
   */
  notes: AutoExecutionHistoryNote[];
};

/**
 * Describes the message bffuser.v1.AutoExecutionHistoryEntry.
 * Use `create(AutoExecutionHistoryEntrySchema)` to create a new message.
 */
export const AutoExecutionHistoryEntrySchema: GenMessage<AutoExecutionHistoryEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_history_model, 0);

/**
 * AutoExecutionHistorySubStepTarget is the target of a row of an automation
 * inside a workflow case.
 *
 * @generated from message bffuser.v1.AutoExecutionHistorySubStepTarget
 */
export type AutoExecutionHistorySubStepTarget = Message<"bffuser.v1.AutoExecutionHistorySubStepTarget"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * area_code is UNSPECIFIED when the case has no area.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * sub_step_name is absent when the sub-step is no longer in the case.
   *
   * @generated from field: optional string sub_step_name = 4;
   */
  subStepName?: string;
};

/**
 * Describes the message bffuser.v1.AutoExecutionHistorySubStepTarget.
 * Use `create(AutoExecutionHistorySubStepTargetSchema)` to create a new message.
 */
export const AutoExecutionHistorySubStepTargetSchema: GenMessage<AutoExecutionHistorySubStepTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_history_model, 1);

/**
 * AutoExecutionHistoryMethod is the 手法 recorded at the time of the attempt.
 *
 * @generated from message bffuser.v1.AutoExecutionHistoryMethod
 */
export type AutoExecutionHistoryMethod = Message<"bffuser.v1.AutoExecutionHistoryMethod"> & {
  /**
   * @generated from oneof bffuser.v1.AutoExecutionHistoryMethod.method
   */
  method: {
    /**
     * @generated from field: bffuser.v1.DemandAutoConfirmMethod demand_forecast = 1;
     */
    value: DemandAutoConfirmMethod;
    case: "demandForecast";
  } | {
    /**
     * @generated from field: bffuser.v1.PlanCreateHistoryMethod plan_create = 2;
     */
    value: PlanCreateHistoryMethod;
    case: "planCreate";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.AutoExecutionHistoryMethod.
 * Use `create(AutoExecutionHistoryMethodSchema)` to create a new message.
 */
export const AutoExecutionHistoryMethodSchema: GenMessage<AutoExecutionHistoryMethod> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_history_model, 2);

/**
 * PlanCreateHistoryMethod is the 手法 of 計画の自動作成: the 計画種別 of the plan
 * created and the 計画を作る時刻 resolved for the attempt.
 *
 * @generated from message bffuser.v1.PlanCreateHistoryMethod
 */
export type PlanCreateHistoryMethod = Message<"bffuser.v1.PlanCreateHistoryMethod"> & {
  /**
   * @generated from field: bfftypes.v1.PlanSubmissionKind plan_kind = 1;
   */
  planKind: PlanSubmissionKind;

  /**
   * @generated from field: bffuser.v1.PlanCreationTime creation_time = 2;
   */
  creationTime?: PlanCreationTime;
};

/**
 * Describes the message bffuser.v1.PlanCreateHistoryMethod.
 * Use `create(PlanCreateHistoryMethodSchema)` to create a new message.
 */
export const PlanCreateHistoryMethodSchema: GenMessage<PlanCreateHistoryMethod> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_history_model, 3);

/**
 * AutoExecutionHistoryNote is one 備考. dates is empty when the reason applies
 * to every day of the 対象受渡日; otherwise it lists those days ascending.
 *
 * @generated from message bffuser.v1.AutoExecutionHistoryNote
 */
export type AutoExecutionHistoryNote = Message<"bffuser.v1.AutoExecutionHistoryNote"> & {
  /**
   * @generated from field: bffuser.v1.AutoExecutionNoteReason reason = 1;
   */
  reason: AutoExecutionNoteReason;

  /**
   * @generated from field: repeated google.type.Date dates = 2;
   */
  dates: Date[];
};

/**
 * Describes the message bffuser.v1.AutoExecutionHistoryNote.
 * Use `create(AutoExecutionHistoryNoteSchema)` to create a new message.
 */
export const AutoExecutionHistoryNoteSchema: GenMessage<AutoExecutionHistoryNote> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_history_model, 4);

/**
 * AutoExecutionResult is the 結果 of a row (AC-AEH-003).
 *
 * @generated from enum bffuser.v1.AutoExecutionResult
 */
export enum AutoExecutionResult {
  /**
   * @generated from enum value: AUTO_EXECUTION_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTO_EXECUTION_RESULT_EXECUTED = 1;
   */
  EXECUTED = 1,

  /**
   * @generated from enum value: AUTO_EXECUTION_RESULT_AWAITING_APPROVAL = 2;
   */
  AWAITING_APPROVAL = 2,

  /**
   * @generated from enum value: AUTO_EXECUTION_RESULT_APPROVAL_HELD = 3;
   */
  APPROVAL_HELD = 3,

  /**
   * @generated from enum value: AUTO_EXECUTION_RESULT_SKIPPED = 4;
   */
  SKIPPED = 4,

  /**
   * @generated from enum value: AUTO_EXECUTION_RESULT_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum bffuser.v1.AutoExecutionResult.
 */
export const AutoExecutionResultSchema: GenEnum<AutoExecutionResult> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_automation_history_model, 0);

/**
 * AutoExecutionNoteReason is the reason of a 備考 (AC-AEH-004); the wording
 * belongs to the screen.
 *
 * @generated from enum bffuser.v1.AutoExecutionNoteReason
 */
export enum AutoExecutionNoteReason {
  /**
   * @generated from enum value: AUTO_EXECUTION_NOTE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTO_EXECUTION_NOTE_REASON_DEMAND_BG_NOT_FOUND = 1;
   */
  DEMAND_BG_NOT_FOUND = 1,

  /**
   * @generated from enum value: AUTO_EXECUTION_NOTE_REASON_METHOD_UNDECIDABLE = 2;
   */
  METHOD_UNDECIDABLE = 2,

  /**
   * @generated from enum value: AUTO_EXECUTION_NOTE_REASON_NO_ACTUALS_ALL_ZERO = 3;
   */
  NO_ACTUALS_ALL_ZERO = 3,

  /**
   * @generated from enum value: AUTO_EXECUTION_NOTE_REASON_NOT_COMPLETED = 4;
   */
  NOT_COMPLETED = 4,

  /**
   * @generated from enum value: AUTO_EXECUTION_NOTE_REASON_PAST_DELIVERY_DATE = 5;
   */
  PAST_DELIVERY_DATE = 5,
}

/**
 * Describes the enum bffuser.v1.AutoExecutionNoteReason.
 */
export const AutoExecutionNoteReasonSchema: GenEnum<AutoExecutionNoteReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_automation_history_model, 1);

